import { ButtonType, EpicIcons } from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import { useContext } from "react";
import { useTranslation } from "@i18n/hooks";
import { type ProductsTableFiltersState } from "./products-table-filters.types";
import { Button } from "../../../../components/button";
import {
	DefaultTextFieldComponent,
	DefaultYesNoFieldComponent,
} from "../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../components/ValidatedField";
import { ProductsScreenContext } from "../../products.context";
import { headerWrapperClass, wrapperClass } from "../../products.styles";

export const ProductsTableFilters = () => {
	const { t } = useTranslation("common");
	const { setFilters } = useContext(ProductsScreenContext);

	const initialValues: ProductsTableFiltersState = {
		isHiddenOpt: undefined,
		titleOpt: undefined,
	};

	const formik = useFormik<ProductsTableFiltersState>({
		initialValues,
		onSubmit: (values: ProductsTableFiltersState, { setSubmitting }) => {
			setFilters(values);
			setSubmitting(false);
		},
	});

	const clearForm = () => {
		formik.handleReset(initialValues);
		formik.handleSubmit();
	};

	return (
		<form onSubmit={formik.handleSubmit} className="p-fluid">
			<div className={headerWrapperClass}>
				<div className={wrapperClass}>
					<ValidatedField<ProductsTableFiltersState, boolean>
						name="isHiddenOpt"
						label={t("product.isHidden")}
						className="mr-2"
						component={DefaultYesNoFieldComponent}
						formikConfig={formik}
					/>
					<ValidatedField<ProductsTableFiltersState, string>
						name="titleOpt"
						label={t("product.nameLabel")}
						className="mr-2"
						component={DefaultTextFieldComponent}
						formikConfig={formik}
					/>
				</div>
				<div className={wrapperClass}>
					<Button
						disabled={false}
						type={ButtonType.Reset}
						onClick={clearForm}
						icon={EpicIcons.TIMES}
					/>
					<Button disabled={false} type={ButtonType.Submit} icon={EpicIcons.SEARCH} />
				</div>
			</div>
		</form>
	);
};
